import React, {useEffect, useRef, useState} from "react";
import './MainMenu.css';
import NavbarTop from "./navigations/NavbarTop";
import WorldMap from "../../pages/WorldMap";
import {isMobile, isTablet} from "react-device-detect";
import NavbarBottom from "./navigations/NavbarBottom";
import stories from "./worldMap/stories/stories";
import {useTypedSelector} from "../../hooks/useTypedSelector";
import TutorialComponent from "../tutorial/TutorialComponent";
type Props = {
    children: React.ReactNode;
};

function MainMenu({ children }: Props) {

    const {user, tutorial, route} = useTypedSelector(state => state.auth);

    const bgRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [start, setStart] = useState<{ x: number; y: number } | null>(null);

    const onStart = (e: React.MouseEvent | React.TouchEvent) => {
        const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
        const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
        setStart({ x: clientX - position.x, y: clientY - position.y });
        e.preventDefault();
    };

    const onMove = (e: MouseEvent | TouchEvent) => {
        if (!start || tutorial.isActive || route !== 'home') return;
        const clientX = 'touches' in e ? e.touches[0].clientX : (e as MouseEvent).clientX;
        const clientY = 'touches' in e ? e.touches[0].clientY : (e as MouseEvent).clientY;
        setPosition(prev => {
            const container = containerRef.current;
            const bg = bgRef.current;
            if (!container || !bg) return prev;

            const containerRect = container.getBoundingClientRect();
            const maxOffsetX = 0;
            const minOffsetX = containerRect.width - bg.offsetWidth;

            const maxOffsetY = 0;
            const minOffsetY = containerRect.height - bg.offsetHeight;

            const newX = Math.min(maxOffsetX, Math.max(minOffsetX, clientX - start.x));
            const newY = Math.min(maxOffsetY, Math.max(minOffsetY, clientY - start.y));

            return { x: newX, y: newY };
        });
    };

    const onEnd = () => setStart(null);

    useEffect(() => {
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onEnd);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
        return () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onEnd);
            document.removeEventListener('touchmove', onMove);
            document.removeEventListener('touchend', onEnd);
        };
    }, [start]);

    useEffect(() => {
        let targetClass = 'mapArenaIcon';

        // Якщо активний конкретний крок туторіалу, центруємось на арені
        if (!(tutorial.step === 'ArenaStart200' && tutorial.isActive)) {
            for (const [key, StoryComponent] of Object.entries(stories)) {
                if (key === 'PromoStory') continue;

                const cpuIds = [StoryComponent.cpu1?.id, StoryComponent.cpu2?.id, StoryComponent.cpu3?.id];

                const isAnyCpuMissing = cpuIds.some(id => id && !user.maps.includes(id));

                if (isAnyCpuMissing) {
                    targetClass = StoryComponent.classCss;
                    break;
                }
            }
        }

        const bg = bgRef.current;
        const container = containerRef.current;
        const target = document.querySelector('.' + targetClass);

        if (!bg || !container || !target) return;

        requestAnimationFrame(() => {
            const bgRect = bg.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();

            const relX = (targetRect.left - bgRect.left) + targetRect.width / 2;
            const relY = (targetRect.top - bgRect.top) + targetRect.height / 2;

            const viewportCenterX = containerRect.left + containerRect.width / 2;
            const viewportCenterY = containerRect.top + containerRect.height / 2;

            const offsetX = viewportCenterX - relX;
            const offsetY = viewportCenterY - relY;

            const minOffsetX = containerRect.width - bgRect.width;
            const minOffsetY = containerRect.height - bgRect.height;

            const x = Math.min(0, Math.max(minOffsetX, offsetX));
            const y = Math.min(0, Math.max(minOffsetY, offsetY));

            setPosition({ x, y });
        });
    }, [user, tutorial.step, tutorial.isActive]);


    const height = window.innerHeight;
    let zoom = 100;
    if (isMobile) {
        zoom = Math.round((6 / 35) * height - 3.71);
    }

    if(isTablet) {
        zoom = 87;
    }

    let stringZoom = zoom.toString();
    stringZoom += '%';

    return (
        <div
            ref={containerRef}
            className="viewport"
            onMouseDown={onStart}
            onTouchStart={onStart}
        >
            <div
                ref={bgRef}
                className="main_menu_container"
                style={{
                    transform: `translate(${position.x}px, ${position.y}px)`
                }}
            >
                <div className="world_map_container" style={{zoom: stringZoom}}>
                  <WorldMap />
                </div>
            </div>

            <div className="main_menu_content" style={{zoom: stringZoom}}>
                <TutorialComponent/>
                <NavbarTop />
                {children}
                <NavbarBottom />
            </div>
        </div>
    )
}

export default MainMenu;
